import { circleObject } from "../../utils/utils";
import { FabricPlugin } from "../FabricPlugin";

/**
 * @description Diagrams Plugin. Also used in SmartContractDesigner
 */
export class GeneralEndPlugin extends FabricPlugin {
  fillStyle = "#D15656";

  radius = 20;

  name = "End";

  constructor(options, ctx, data) {
      super(options, ctx, data);
      this.points = { start: 0, end: 10000, initial: 4 };
  }

  draw() {
      const xCenter = this.position.x + this.size.width / 2;
      const yCenter = this.position.y + (this.size.height / 2);
      if (this.size.backgroundRadius) {
          circleObject(xCenter, yCenter, this.size.customRadiusMax + this.size.backgroundRadius, {
              fillStyle: this.size.backgroundColor
          }, this.ctx);
      }
      circleObject(xCenter, yCenter, this.size.customRadiusMax || this.radius, { fillStyle: this.fillStyle }, this.ctx);
      this.fabricPluginRedrawed();
  }

  update(options) {
      this.setPosition(options && options.position ? options.position : super.getPosition());
      this.setSize(options && options.size ? options.size : super.getSize());
  }
}
